<div class="wrapper mb-5">
    <!-- <div class="row logo-container">
        <img src="./assets/icons/logo.svg">
    </div> -->
    <div class="row title-container align-items-center">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Visualizar Grupos</span>
        <button class="action-button" (click)="createGroup()">Criar novo grupo</button>
    </div>
    <div class="row cards">
        <div *ngFor="let item of groups" class="w-30 group-card">
            <div *ngIf="item.countCollaborators == 0" (click)="showModalDeleteGroup(modalDeleteGroup,item)" class="close-group">x</div>
            <div class="row" (click)="detalhesGrupo(item)">
                <div class="span-container mr-3">
                    {{ item.name.charAt(0) }}
                </div>
                <div class="column-center">
                    <span class="label-name">Grupo {{ item.name }}</span>
                    <span class="label-number">{{ item.countCollaborators }} favorecidos</span>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalDeleteGroup let-modal>
    <ng-container>
        <div class="col-12 modal-header clean-modal-header">
            <div class="col-md-12">
                <h5 class="clean-modal-title">Excluir Grupo</h5>
            </div>
        </div>
        <div class="row col-12 clean-modal-content">
            <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">Deseja excluir o grupo?</p>
        </div>
        <div class="col-12 clean-modal-footer">
            <button class="clean-modal-button-text button-cancel mr-2" type="button" (click)="modal.dismiss('Close click')">
                Cancelar
            </button>
            <button class="clean-modal-button" type="button" (click)="deleteGroup();modal.dismiss('Close click')">
                Excluir
            </button>
        </div>
    </ng-container>
</ng-template>
